import { useEffect } from 'react';
import { mapSceneSingleton } from './mapScene';
import useMapViewStore from '../../stores/useMapViewStore';
import { countDeadTextures, requestSceneRebuild } from '../sceneHealth';

/** Give the freshly built map a moment, then make sure every sprite can still draw. */
const CHECK_DELAY_MS = 1500;

/**
 * Once the map's markers are up, look for sprites whose texture can no longer be
 * drawn (see sceneHealth.ts). If there are any — the "bare ocean after a long
 * interior session" state — rebuild the map instead of leaving it empty.
 */
export function useMapSelfHealing(active: boolean): void {
  const markersReady = useMapViewStore((s) => s.markersReady);
  useEffect(() => {
    if (!active || !markersReady) return;
    const timer = window.setTimeout(() => {
      const dead = countDeadTextures(mapSceneSingleton.viewport);
      if (dead > 0) requestSceneRebuild('map_dead_textures', { count: dead });
    }, CHECK_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [active, markersReady]);
}
